/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Duties_OutInputs */

const en_setup_duties_out = /** @type {(inputs: Setup_Duties_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duties out`)
};

/**
* | output |
* | --- |
* | "Duties out" |
*
* @param {Setup_Duties_OutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const setup_duties_out = /** @type {((inputs?: Setup_Duties_OutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Duties_OutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_setup_duties_out(inputs)
});